import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { persistStore } from 'redux-persist';
import { connectRouter } from 'connected-react-router';
import { get } from 'lodash';
import { clearUserData } from './actions/user';
import rootReducer from './reducers';

const createHistory = require('history');

const authenticationMiddleware = store => next => (action) => {
  if (
    get(action, 'payload.error.status') === 401
  ) {
    return store.dispatch(clearUserData());
  }

  return next(action);
};

function configureStoreProd(initialState = {}) {
  const history = createHistory.createBrowserHistory();
  const middleware = [thunk, authenticationMiddleware];

  const store = createStore(
    combineReducers({
      ...rootReducer,
      router: connectRouter(history),
    }),
    initialState,
    compose(
      applyMiddleware(...middleware),
    ),
  );

  const persistor = persistStore(store);

  return { store, persistor, history };
}

function configureStoreDev(initialState = {}) {
  const history = createHistory.createBrowserHistory();
  const middleware = [thunk, authenticationMiddleware];

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const store = createStore(
    combineReducers({
      ...rootReducer,
      router: connectRouter(history),
    }),
    initialState,
    composeEnhancers(
      applyMiddleware(...middleware),
    ),
  );

  const persistor = persistStore(store);

  return { store, persistor, history };
}

const configureStore = process.env.NODE_ENV === 'production' ? configureStoreProd : configureStoreDev;

export default configureStore;
